// Tiny dependency-free confetti burst (~1.5s). Respects prefers-reduced-motion.
export function confetti({ count = 140, duration = 1500 } = {}) {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

  const canvas = document.createElement("canvas")
  canvas.className = "confetti-canvas"
  canvas.width = window.innerWidth
  canvas.height = window.innerHeight
  document.body.appendChild(canvas)
  const ctx = canvas.getContext("2d")
  const colors = ["#4e73df", "#1cc88a", "#f6c23e", "#e74a3b", "#6889e8"]

  const pieces = Array.from({ length: count }, () => ({
    x: canvas.width / 2 + (Math.random() - 0.5) * 200,
    y: canvas.height / 3,
    vx: (Math.random() - 0.5) * 14,
    vy: -Math.random() * 12 - 4,
    size: Math.random() * 8 + 4,
    rotation: Math.random() * 360,
    spin: (Math.random() - 0.5) * 20,
    color: colors[Math.floor(Math.random() * colors.length)]
  }))

  const start = performance.now()
  function frame(now) {
    const t = now - start
    ctx.clearRect(0, 0, canvas.width, canvas.height)
    ctx.globalAlpha = Math.max(0, 1 - t / duration)
    for (const p of pieces) {
      p.vy += 0.35
      p.x += p.vx
      p.y += p.vy
      p.rotation += p.spin
      ctx.save()
      ctx.translate(p.x, p.y)
      ctx.rotate((p.rotation * Math.PI) / 180)
      ctx.fillStyle = p.color
      ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6)
      ctx.restore()
    }
    if (t < duration) requestAnimationFrame(frame)
    else canvas.remove()
  }
  requestAnimationFrame(frame)
}
